$( document ).ready(function() {
// product page metafield accordion js
        $(".accordion_head").click(function () {
          if ($('.accordion_body').is(':visible')) {
              $(".accordion_body").slideUp(300);
              $(".plusminus").text('+');
          }
          if ($(this).next(".accordion_body").is(':visible')) {
              $(this).next(".accordion_body").slideUp(300);
              $(this).children(".plusminus").text('+');
              $(this).removeClass("active");
          } else {
              $(this).next(".accordion_body").slideDown(300);
              $(this).children(".plusminus").text('-');
               $(this).addClass("active")
          }
      });


  
// sticky add to cart
      $(".dd-SATCbutton").on("click", function name(params) {
      event.preventDefault();
      $(".quantity-submit-row__submit button").trigger("click");
      });
// front add to cart button JS
/*
  $(document).on("click",".dd-add-to-cart",function() {  
   event.preventDefault();
 
        var ID = $(this).attr("first-id"); 
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
        quantity: 1,
        id: ID
        },
        dataType: 'json', 
        success: function (data) {  
          document.documentElement.dispatchEvent(
      new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
          
 
alert("Success");

            console.log("data" , data);  
            $('body').addClass('cc-popup-no-scroll cc-popup-no-scroll-pad-right dd-drawer-open');
            $(".cart-drawer-modal").addClass("cc-popup--visible");
          $.get( "/cart", function(data) {          
            var producthtml = $(data).find('.wrp-dd-line-item').html();
            var subtotal = $(data).find('h2.subtotal .theme-money').html();  
            // console.log("subtotal", subtotal);
            $('.cart-item-list__body .wrp-dd-line-item').html(producthtml); 
            $('.cart-drawer__footer .theme-money').html(subtotal); 
          });
          $.getJSON( "/cart", function( data ) {
              console.log("data" , data);
              var quty = data.item_count;
              // console.log("quty", quty )
              $(".cart-drawer__title-count").html("("+ quty +")") 
              $(".cart-link .cart-link__count").html(quty) 
            if(quty > 0){
              if($(".cart-drawer__content").hasClass("cart-drawer__content--hidden") || $(".cart-drawer__footer").hasClass("cart-drawer__footer--hidden")  ){
              console.log("True");
                $(".cart-drawer__content").removeClass("cart-drawer__content--hidden") ;
                $(".cart-drawer__footer").removeClass("cart-drawer__footer--hidden");
                $(".cart-drawer__empty-content").addClass("cart-drawer__empty-content--hidden")
              }
            }
          });

          
        },
          error: function (){
            alert("Please try again.")
          }
        });
});

*/



  
 /* 
 var swiper = new Swiper(".product-list", {     
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      mousewheel: true,
      keyboard: true,
      breakpoints: {
         768: { 
            slidesPerView: $('.collection-listing .swiper.product-list').attr('coll_par_items'),
            spaceBetween: 12
          },
          200: { 
            slidesPerView: 2,
            centeredSlides: true,           
            spaceBetween: 10
          }
        }
    });
*/
   
});

function addtoCart(el,idvalue)
{ 
  const product_block = el.closest('.product-block');
  if (product_block){
    var size_options = product_block.querySelector('.new_options');
    if(size_options){
      if(!product_block.classList.contains('active_newoptions')){
        product_block.classList.add('active_newoptions');
        return;
      }
    }
  }
 
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
            quantity: 1,
            id: idvalue
          },
    dataType: 'json', 
    success: function (data) { 
      /*document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));*/
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {bubbles: true, cancelable: false, detail: {openDrawer: true} }));

      document.querySelectorAll('.product-block').forEach(item=>{item.classList.remove('active_newoptions');});
    },
    error: function()
    {
      alert("Please try again.")    
    }
  });
}
 

/*
function addtoCart2(el, varid){
   if(el.classList.contains('added_already')) return; // prevent double fire
     el.classList.add('added_already');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
            quantity: 1,
            id: varid
          },
    dataType: 'json', 
    success: function (data) {  
      el.classList.add('added_already');
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {bubbles: true, cancelable: false, detail: {openDrawer: false} })); 
    },
    error: function()
    {
      el.classList.remove('added_already'); // re-enable on error
      var checkbox = el.querySelector('input[type="checkbox"]');
      if(checkbox) checkbox.checked = false;
      alert("Please try again.")    
    }
  });


}
*/


function addtoCart2(e, el, varid) {
  e.preventDefault(); // stops checkbox from firing a second click
  
  if (el.classList.contains('added_already')) {
    // REMOVE from cart
    el.classList.remove('added_already');
    var checkbox = el.querySelector('input[type="checkbox"]');
    if (checkbox) checkbox.checked = false;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const item = cart.items.find(i => i.variant_id == varid);
        if (!item) return; // already not in cart, nothing to do

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: { id: item.key, quantity: 0 },
          dataType: 'json',
          success: function() {
            document.documentElement.dispatchEvent(
              new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: false } })
            );
          },
          error: function(xhr) {
            console.error('Remove error:', xhr.responseText);
            el.classList.add('added_already');
            if (checkbox) checkbox.checked = true;
          }
        });
      });

    return;
  }

  // ADD to cart
  el.classList.add('added_already');
  var checkbox = el.querySelector('input[type="checkbox"]');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { quantity: 1, id: varid },
    dataType: 'json',
    success: function() {
      if (checkbox) checkbox.checked = true;
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: false } })
      );
    },
    error: function(xhr) {
      console.error('Add error:', xhr.responseText); // check browser console for real reason
      el.classList.remove('added_already');
      if (checkbox) checkbox.checked = false;
      // Temporarily show actual error instead of generic message:
      const err = JSON.parse(xhr.responseText || '{}');
      alert(err.description || err.message || "Please try again.");
    }
  });
}


  // $(window).on('load', function() {      
  //     $( ".product-slideshow .slide").each(function( index ) {
  //       if($(this).find().hasClass(".product-media .product-media__video-play-btn")){
  //         debugger
  //         var ply_video = $(this).find(".product-media__video-play-btn")
  //         $(ply_video).click();
          
  //         console.log(index ,"dd-this", this , "video")
  //       } else {
  //         console.log(index , "image")
  //       }  
  //     });
  // })

$(document).on({
    mouseenter: function () {
        $(".product-block__image--secondary").removeClass('product-block__image--inactivated');
    },
    mouseleave: function () {
       
    }
}, ".image-cont--with-secondary-image");


function checkfreegift(){ 
  var shippingbar = document.querySelector('free-shipping-bar.customFreeShippingBar');
  if(!shippingbar)return;
  
  var rateConversion = Shopify?.currency?.rate || 1;;
  var cartPrice = parseInt(shippingbar.dataset.carttotal);

  var manualgift = document.querySelector('#manualgiftPrice'); 
  var manualgiftPrice = parseInt(manualgift.textContent);
  manualgiftPrice = rateConversion*manualgiftPrice;
  var formattedmanualgiftPrice = Shopify.formatMoney(manualgiftPrice, Shopify.money_format);
  var manualpending = manualgiftPrice - cartPrice;
  var manualpendingPriceFormat = Shopify.formatMoney(manualpending, Shopify.money_format);
  var manualpercentage = (cartPrice/manualgiftPrice)*100;
  if(manualpercentage<0){manualpercentage=0}else if(manualpercentage>100){manualpercentage=100}

  shippingbar.style.setProperty('--progress', manualpercentage+"%"); 

  var dec_text = document.querySelector('#dec_text'); 
  var addgift1 = false, addgift2 = false;

  var autogift = document.querySelector('#autogiftPrice');
  var autogiftPrice; 
  var formattedautogiftPrice; 
  var autopending;
  var autopendingPriceFormat;
  var autopercentage; 
  var valueHere_gift1,valueHere_gift2; 
  if(autogift){
    autogiftPrice = parseInt(autogift.textContent);
    autogiftPrice = rateConversion*autogiftPrice;
    formattedautogiftPrice = Shopify.formatMoney(autogiftPrice, Shopify.money_format); 
    autopending = autogiftPrice - cartPrice;
    autopendingPriceFormat = Shopify.formatMoney(autopending, Shopify.money_format);
    autopercentage = (cartPrice/autogiftPrice)*100;
    if(autopercentage<0){autopercentage=0}else if(autopercentage>100){autopercentage=100}

       
    var progresswidth = document.querySelector('span.giftPrice.gift_a1');
    valueHere_gift1 = 100 - (((manualgiftPrice - autogiftPrice)*100)/manualgiftPrice);
    if(progresswidth)progresswidth.style.width = valueHere_gift1 + "%";
    if(cartPrice>=autogiftPrice){
      progresswidth.classList.add("Active");
      dec_text.dataset.gift1 = "true";
    }else{
      progresswidth.classList.remove("Active");
      dec_text.dataset.gift1 = "false";
    }
  }


  var progresswidth2 = document.querySelector('span.giftPrice.gift_a2');
  valueHere_gift2 = 100 - valueHere_gift1;
  if(progresswidth2)progresswidth2.style.width = valueHere_gift2 + "%";
  if(cartPrice>=manualgiftPrice){
    progresswidth2.classList.add("Active");
    dec_text.dataset.gift2 = "true";
  }else{
    progresswidth2.classList.remove("Active");
    dec_text.dataset.gift2 = "false";
  }


  if(cartPrice >= manualgiftPrice)
  {
    dec_text.innerHTML = allachieved;
  }else{
      if(cartPrice >= autogiftPrice && autogift)
      {
        dec_text.innerHTML = gift1_achieved;
      }else{
        if(autogift){
          dec_text.innerHTML = to_achieve_gift1;
        }else{
          dec_text.innerHTML = to_achieve_gift2;
        }
      }
  }
  
 
 

  document.querySelectorAll('.maxthrehhold').forEach(element => {
    element.innerHTML = formattedmanualgiftPrice;
  });
  document.querySelectorAll('.pendingfromgift2').forEach(element => {
    element.innerHTML = manualpendingPriceFormat;
  }); 


  document.querySelectorAll('.autothrehhold').forEach(element => {
    element.innerHTML = formattedautogiftPrice;
  });
  document.querySelectorAll('.pendingfromgift1').forEach(element => {
    element.innerHTML = autopendingPriceFormat;
  });

 
  var selectionValue = document.querySelector('html').getAttribute('data-selection');
  if(selectionValue == "men"){
    document.querySelector(".upsellGiftProducts .menCategory1")?.classList.add("active");
    document.querySelector(".upsellGiftProducts .womenCategory1")?.classList.remove("active");
  }else{
    document.querySelector(".upsellGiftProducts .womenCategory1")?.classList.add("active");
    document.querySelector(".upsellGiftProducts .menCategory1")?.classList.remove("active");
  }
  
  shippingbar.classList.remove("loading");
  
 
  var textelem = document.querySelector('free-shipping-bar.customFreeShippingBar span.shipping-bar__text.text--small');
  // check automatic gift
  if(textelem.dataset.gift1=="true"){
    //auto gift must be there
    if(document.querySelector('.gift_product_auto')){
      // already there
    }else{
      var button_atc = document.querySelector('free-shipping-bar.customFreeShippingBar form button.dd-add-to-cart');
      if(button_atc){
        console.log('add it!!!!!!!!!!!!!!!!');
        button_atc.click();
        return;
      }
    } 
  }else{
    //remove it if already there
    var button_remove = document.querySelector('.gift_product_auto a.cart-item__remove');
    if(button_remove){
      console.log('remove it!!!!!!!!!!!!!!!!');
      button_remove.click();  
      return;
    }
  }

  
  // now check manual gift
  if(textelem.dataset.gift2=="true"){
    //manual gift can be added
    if(document.querySelector('.gift_product_manual')){
      // already there
    }  
  }else{
    //remove it if already there
    //var button_remove = document.querySelector('.gift_product_manual a.cart-item__remove');
    //if(button_remove)button_remove.click();  

    //no need to remove, as we are discounting with an automatic discount
  }
}

 
function selectSeparate(selec){ 
  if(selec == 1){
    document.querySelector(".upsellGiftProducts .menCategory1")?.classList.add("active");
    document.querySelector(".upsellGiftProducts .womenCategory1")?.classList.remove("active");
  }else{
    document.querySelector(".upsellGiftProducts .womenCategory1")?.classList.add("active");
    document.querySelector(".upsellGiftProducts .menCategory1")?.classList.remove("active");
  }
}


window.addEventListener('theme:cartchanged', (event) => {

  if (document.querySelector('.cartTopMessage'))
  {
  var urlConstruct = '/cart?view=dynamicMessage';
    $.ajax({
    url: urlConstruct, 
    type:'GET',
    dataType: 'html',
    success: function(response) {    
      $('.cartTopMessage').html(response);
    }
    }); 
  }

  if (document.querySelector('.cartTopMessage2'))
  {
  var urlConstruct = '/cart?view=giftdynamicmessage';
    $.ajax({
    url: urlConstruct, 
    type:'GET',
    dataType: 'html',
    success: function(response) {    
  
      // Parse the response and extract only #simplewrapper content
      var tempDiv = $('<div>').html(response);
      var newContent = tempDiv.find('#simplewrapper').html();

      // Replace existing #simplewrapper content with new one
      $('#simplewrapper').html(newContent);

      //$('.cartTopMessage2').html(simpleWrapper);
      setTimeout(checkfreegift,2000);
    }
    });  
  }

});



Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
get: function () {return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);}});
document.body.addEventListener("click", loadTwoTimes);
document.body.addEventListener("touchstart", loadTwoTimes);
function playVideoOnLowPower(){
try{const videoElements = document.querySelectorAll("video[autoplay]");
for (i = 0; i < videoElements.length; i++) {
if (videoElements[i].playing) {
// video is already playing so do nothing 
}
else {
// video is not playing so play video now
videoElements[i].play(); }}}
catch(err) {console.log(err);}}
function loadTwoTimes()
{playVideoOnLowPower();setTimeout(playVideoOnLowPower,500);
}





function toggleCustomMenu()
{
var menuItem = document.querySelector('li.navigation__item.megaMenuItemMain.onlyForDesktop.navigation__item--with-children.navigation__item--with-mega-menu');

if(menuItem)
{
  menuItem.classList.toggle('navigation__item--show-children');
}
}

document.addEventListener("DOMContentLoaded", (event) => {
  
$('li.navigation__item.megaMenuItemMain ul.mega-menu-right-wrapper-inner').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 7,
  slidesToScroll: 3,
  arrows: true,
  prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23" fill="none"><path d="M14 1L1.5 11.5L14 22.5" stroke="#8E8E8E"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23" fill="none"><path d="M1 22.5L13.5 12L1 1" stroke="#8E8E8E"/></svg></button>' 
});
 

$('.dropdown_link_title_men ul.mega-menu-right-wrapper-inner').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 2,
  arrows: true,
   responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3
      }
    }  
  ],
  prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23" fill="none"><path d="M14 1L1.5 11.5L14 22.5" stroke="#8E8E8E"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23" fill="none"><path d="M1 22.5L13.5 12L1 1" stroke="#8E8E8E"/></svg></button>' 
});

 
setTimeout(function(){ 
$('.mobilemenSlider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 2,
  arrows: true,
  prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23" fill="none"><path d="M14 1L1.5 11.5L14 22.5" stroke="#8E8E8E"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23" fill="none"><path d="M1 22.5L13.5 12L1 1" stroke="#8E8E8E"/></svg></button>' 
});
},1000); 
  

 setTimeout(checkfreegift,2000);
});
  
document.addEventListener("shopify:section:load", (event) => { 
 setTimeout(checkfreegift,2000);
});

 
function opensearch(){
  document.querySelector('.mobile-navigation-drawer a.mobile-nav-toggle')?.click();
  setTimeout(function(){
    document.querySelector('div#pageheader a.show-search-link')?.click();
  },340);
}



  
function initnewsletterradios(){
  if(!document.querySelector("form#footer_newsletter_signup"))return;

  const radios = document.querySelectorAll('input[name="newsletter_type"]');
  const tagInput = document.getElementById("newsletter_tags");

  radios.forEach(radio => {
    radio.addEventListener("change", function() {

      if (this.value === "men") {
        tagInput.value = "prospect,newsletter,men";
      }

      if (this.value === "women") {
        tagInput.value = "prospect,newsletter,women";
      }

      if (this.value === "all") {
        tagInput.value = "prospect,newsletter";
      }

    });
  }); 
}
initnewsletterradios();